import React, {useEffect, useState} from 'react';
import Cookie from "js-cookie";
import {makeStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import "./Navbar.scss";
import {ReactComponent as ExitIcon} from "./partial/exit-icon.svg";
import {ReactComponent as UserAvatarIcon} from "~/common/icons/user-avatar.svg";
import {APP_ORIGIN, APP_PRIVATE_AREA_ORIGIN} from '../../common/config/global';
import {useTranslation} from "react-i18next";
import {API} from '../../services'
import chatroomReducer from '../../ducks/chatroom/reducers';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
}));




export default function DenseAppBar() {
  const classes = useStyles();
  const {t} = useTranslation();

  const exitChat = (e) => {
	Cookie.set('chat_status', 'off');
	window.location.href = APP_PRIVATE_AREA_ORIGIN;
  };

  const [user, setUser] = useState({});
console.log(user, 'user')
  useEffect(() => {
    (async() => {
      try {
        const {data: {user}} = await API.getApplicationInitState()
        setUser(user)
      } catch(err){
        console.error(err)
      }
    })()
  }, []);


  return (
    <div className={classes.root}>
      <AppBar className="navbar" position="static">
        <Toolbar variant="dense">
          <div className="mainLogoWrapper">
            <a href="/"><img className="mainLogo" src="/images/common/logo_main.png" alt={t('main_logo')}/></a>
          </div>
          <div className="exitChatWrapper">
            <ExitIcon/>
            <a onClick={exitChat} >{t('exit_chat')}</a>
          </div>
          <div className="currentUserWrapper">
            {user?.avatar && <div className={"currentAvatarWrapper"}>
              <img src={user?.avatar} alt=""/>
            </div>}
            {!user?.avatar && <div className={"currentAvatarWrapper"}>
              <div className="empty-avatar">
                <UserAvatarIcon/>
              </div>
            </div>}
            <p>{user?.username}</p>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
}
